import { Box, Text, Flex } from '@chakra-ui/react';
import React from 'react';
import DirectionsIcon from '../../assets/icons/directions-pin.svg';

interface DirectionsButtonProps {
  googleMapsUrl: string;
}

const DirectionsButton: React.FC<DirectionsButtonProps> = ({
  googleMapsUrl,
}) => {
  const openGoogleMaps = () => {
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <Flex
      as="a"
      onClick={openGoogleMaps}
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap="0.375rem"
      bg="transparent"
      border="none"
      _hover={{ textDecoration: 'underline', cursor: 'pointer' }}
    >
      <Box
        as="img"
        src={DirectionsIcon}
        alt="Directions Icon"
        width="1rem"
        height="1rem"
      />
      <Text
        color="text.brandLight"
        fontSize="0.75rem"
        fontStyle="normal"
        fontWeight="500"
        lineHeight="1rem"
      >
        Directions
      </Text>
    </Flex>
  );
};

export default DirectionsButton;
